/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@digital-hig/grid';
import Button from '@digital-hig/button';
import { useNavigate, useParams } from 'react-router-dom';
import Typography from '@digital-hig/typography';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Skeleton from '@mui/material/Skeleton';
import StoriesRootElement from './style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { LOAD_MORE_STORIES_LENGTH, SUCCESS_STORIES_LENGTH } from '../../../constants/app-constants';
import { isMobileDevice } from '../../../utils/srp.util';
import CardDetails from '../../../common/cardDetails/cardDetails';
import CardCarousel from '../../../common/cardDetails/cardCarousel';
import ListingShimmer from '../../srp/Listing/listingShimmer';
import { getSuccessStoriesCardBaseURL } from '../../../utils/success-stories.util';

const ExploreSuccessStories = ({
  profileDetails = {}, loading = false, scrollRef = {},
}) => {
  const { successStories } = profileDetails || {};
  const navigate = useNavigate();
  const param = useParams();
  const [stories, setStories] = useState([]);
  const { t } = useTranslation();
  const loadMoreStories = () => {
    const moreStories = [...stories, ...successStories.slice(stories.length, stories.length + LOAD_MORE_STORIES_LENGTH)];
    setStories(moreStories);
  };

  const getLink = (element) => getSuccessStoriesCardBaseURL(param.locale, { name: element.title, id: element.id });

  useEffect(() => {
    if (successStories) {
      setStories(successStories.slice(0, SUCCESS_STORIES_LENGTH));
    }
  }, [successStories]);

  const handleViewMore = async (item) => {
    if (item.title) {
      const baseUrl = getLink(item);
      navigate(baseUrl);
    }
  };

  return (
    <>
      {stories.length > 0 && (
        // eslint-disable-next-line
        <StoriesRootElement ref={(el) => (scrollRef.current[6] = el)}>
          <Box className="page-container">
            <Typography variant="headline-medium" mb={6} component="h3">
              {t('Explore')}
              {param.locale !== 'jp' && (
                <>
                  {' '}
                  {t('more')}
                  {' '}
                  {t('Success stories').toLowerCase()}
                </>
              )}
            </Typography>
            {!isMobileDevice() && (
              <Grid className="grid-col">
                {!!stories?.length && stories.map((story) => (
                  <CardDetails
                    link={getLink(story)}
                    dataWatLoc="success stories"
                    dataWatVal="story title"
                    handleViewMore={() => handleViewMore(story)}
                    key={`stories-${story.id}`}
                    headline={story?.customer_challenge}
                    displayName={story?.title}
                    view
                  />
                ))}
                {loading && [...Array(4).keys()].map((idx) => (
                  <ListingShimmer key={idx} img={false} />
                ))}
              </Grid>
            )}
            {isMobileDevice() && (
              <CardCarousel
                pagination={{ total_count: successStories?.length, next_page: false }}
                dataWatLoc="success stories"
                dataWatVal="story title"
                getLink={getLink}
                handleViewMore={handleViewMore}
                partners={successStories}
                loading={loading}
                profile
                view
              />
            )}
            {!isMobileDevice() && (
              <Box className="load-more">
                {!loading && (
                  <Button
                    size="medium"
                    data-wat-loc="success stories"
                    data-wat-val="load more"
                    disabled={stories?.length === successStories?.length}
                    variant="contained"
                    onClick={loadMoreStories}
                  >
                    {t('Load more')}
                  </Button>
                )}
                {loading && <Skeleton height="55px" width="120px" />}
              </Box>
            )}
          </Box>
        </StoriesRootElement>
      )}
    </>
  );
};

/* eslint react/require-default-props: off */
ExploreSuccessStories.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
  scrollRef: PropTypes.shape({}),
};
export default ProfileContextConsumer(ExploreSuccessStories);
